import { Chip } from '@mui/material';
import { toProperCase } from '@core/utils/string';
import type { Order } from '../../api/order';
import { ORDER_STATUS_PALETTE } from '../enum/orderStatus';

interface OrderStatusChipProps {
  order: Order;
}

const OrderStatusChip = ({ order }: OrderStatusChipProps) => {
  const palette = ORDER_STATUS_PALETTE[order.status];
  return (
    <Chip
      size="small"
      label={toProperCase(order.status)}
      sx={{
        fontWeight: 'bold',
        letterSpacing: '0.25px',
        color: `${palette}.900`,
        bgcolor: `${palette}.100`,
        borderColor: `${palette}.900`,
        border: '1px solid',
      }}
    />
  );
};

export default OrderStatusChip;
